const MIME_FILE_EXTENSIONS = {
    "image/jpeg": [".jpg", ".jpeg"],
    "image/png": [".png"],
    "image/gif": [".gif"],
    "image/webp": [".webp"],
    "video/mp4": [".mp4", ".m4v"],
    "video/3gpp": [".3gp", ".3gpp"],
    "video/quicktime": [".mov", ".qt"],
    "video/webm": [".webm"],
    "video/ogg": [".ogv", ".ogg"],
    "audio/aac": [".aac"],
    "audio/amr": [".amr"],
    "audio/mpeg": [".mp3"],
    "audio/mp4": [".m4a", ".mp4"],
    "audio/ogg": [".ogg", ".opus"],
    "audio/wav": [".wav"],
    "audio/m4a": [".m4a"],
    "application/pdf": [".pdf"],
    "text/plain": [".txt"],
    "application/msword": [".doc"],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
    "application/vnd.ms-excel": [".xls"],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
    "application/vnd.ms-powerpoint": [".ppt"],
    "application/vnd.openxmlformats-officedocument.presentationml.presentation": [".pptx"],
};
function normalizeMime(mime) {
    return mime.toLowerCase().split(";")[0]?.trim() ?? "";
}
/** Broad `video/*` advertises MOV. Only platforms that accept QuickTime should use it. */
function allowsBroadVideoPicker(capabilities) {
    return capabilities.entries.some((entry) => entry.attachmentType === "VIDEO" &&
        entry.allowedMimeTypes.some((mime) => normalizeMime(mime) === "video/quicktime"));
}
/**
 * Builds a browser file-picker `accept` attribute from platform capabilities.
 * Includes MIME types, common extensions, and broad image/video categories so
 * mobile pickers (Safari/iOS) expose supported files.
 */
export function buildOutboundMediaAcceptAttribute(capabilities) {
    const parts = new Set();
    let hasImage = false;
    let hasVideo = false;
    let hasAudio = false;
    for (const entry of capabilities.entries) {
        if (entry.attachmentType === "IMAGE" || entry.attachmentType === "STICKER") {
            hasImage = true;
        }
        if (entry.attachmentType === "VIDEO") {
            hasVideo = true;
        }
        if (entry.attachmentType === "AUDIO") {
            hasAudio = true;
        }
        for (const mime of entry.allowedMimeTypes) {
            const normalized = normalizeMime(mime);
            if (!normalized) {
                continue;
            }
            parts.add(normalized);
            for (const ext of MIME_FILE_EXTENSIONS[normalized] ?? []) {
                parts.add(ext);
            }
        }
    }
    if (hasImage) {
        parts.add("image/*");
    }
    if (hasVideo && allowsBroadVideoPicker(capabilities)) {
        parts.add("video/*");
    }
    if (hasAudio) {
        parts.add("audio/*");
    }
    return [...parts].sort().join(",");
}
export { MIME_FILE_EXTENSIONS };
//# sourceMappingURL=outbound-media-accept.js.map